export default "__VITE_ASSET__DThWaXzr__"